/**
 * Composable for managing rebooking state
 */
import { ref, computed } from 'vue'
import { useTravelSelection } from './useTravelSelection'

export function useRebookingState() {
  // Use the travel selection composable
  const { processSelectedTravel } = useTravelSelection()
  
  // Reactive state
  const rebookingStarted = ref(false)
  const errorMessage = ref<string | undefined>(undefined)
  
  // Computed properties
  const isButtonDisabled = computed(() => {
    return rebookingStarted.value
  })
  
  /**
   * Set rebooking started state
   */
  const setRebookingStarted = (value: boolean) => {
    rebookingStarted.value = value
  }
  
  /**
   * Set error message
   */
  const setErrorMessage = (message: string | undefined) => {
    errorMessage.value = message
  }
  
  return {
    rebookingStarted,
    errorMessage,
    isButtonDisabled,
    processSelectedTravel,
    setRebookingStarted,
    setErrorMessage
  }
}
